import React, { useEffect } from "react";
import Header from "../components/Header";

const faqs = [
  {
    q: "Как работает сервис?",
    a: "Сервис генерирует черновик бизнес-плана по типовой структуре для соцконтракта. Вы описываете идею → попадаете в редактор где ИИ генерирует бизнес план → после оплаты открывается полный контент, редактирование и возможность скачивание.",
  },
  {
    q: "Нужна ли регистрация, чтобы начать?",
    a: "Начать генерацию можно без регистрации. Авторизация/создание аккаунта происходит при оплате, чтобы сохранить доступ к документу.",
  },
  {
    q: "Что происходит после нажатия «Сгенерировать бизнес-план»?",
    a: "Вы сразу переходите в редактор: видно фиксированную структуру разделов, а текстовые блоки временно \"закрашены\". Полный текст станет доступен после оплаты.",
  },
  {
    q: "Что входит в покупку?",
    a: "Полный сгенерированный текст по всем разделам, возможность редактировать прямо в редакторе, экспорт в PDF/ word DOCX и один повтор генерации.",
  },
  {
    q: "Я точно получу выплату с вашим бизнес-планом?",
    a: "Гарантии нет, т.к. решение принимают органы соц. защиты, которые ориентируются и на другую предоставленную вами информацию. Сгенерированный бизнес план носит информационный характер.",
  },
  {
    q: "Можно ли менять структуру бизнес-плана?",
    a: "Структура разделов фиксирована (под типовой формат), но весь текст внутри разделов редактируем.",
  },
  {
    q: "Если генерация получилась слабой/не по делу — что делать?",
    a: "Используйте включённый в покупку повтор генерации или отредактируйте текст вручную в редакторе. Если проблема повторяется — напишите в поддержку, приложите вашу исходную идею.",
  },
  {
    q: "Поддерживаются ли разные бизнес направления (нишы)?",
    a: "Да. Можно описать любую идею. Есть быстрые пресеты («Кондитерская», «Парикмахерская», «Груминг») — они подставляют стартовую «рыбу» и ориентиры.",
  },
  {
    q: "Какой статус видно до оплаты?",
    a: "В редакторе отображается оглавление и «замочки» на контенте. Внизу — кнопка «Купить бизнес-план». В личном кабинете черновики помечаются как «Не оплачен».",
  },
  {
    q: "Какие форматы экспорта доступны?",
    a: "PDF и DOCX (Word). Экспорт появляется после оплаты.",
  },
  {
    q: "Можно ли скачать без оплаты?",
    a: "Нет. До оплаты доступна только структура и предпросмотр с «шиммером».",
  },
  {
    q: "Какие способы оплаты и это безопасно?",
    a: "Оплата банковскими картами через сертифицированного платёжного провайдера (поддержка 3-D Secure). Данные карт обрабатываются не у нас, а у провайдера, это безопасно.",
  },
  {
    q: "Оплата не проходит — что делать?",
    a: "Проверьте лимиты и 3-D Secure. Если не помогает — напишите в поддержку и укажите время попытки и последние 4 цифры карты (без полного номера).",
  },
  {
    q: "Как храните мои данные и идеи? Можно удалить?",
    a: "Черновики и оплаченные планы сохраняются в личном кабинете. Мы не передаём ваши материалы третьим лицам. Вы можете запросить удаление черновиков и аккаунта — мы удалим их из боевой базы.",
  },
  {
    q: "Соцконтракт: где подавать заявление и кто принимает решение?",
    a: "Подать можно через МФЦ или Госуслуги (порядок зависит от региона). Решение принимает орган социальной защиты вашего региона на основании пакета документов и соответствия условиям программы.",
  },
  {
    q: "Соцконтракт: на что обычно разрешено тратить средства?",
    a: "Как правило — на оборудование, материалы/расходники, создание рабочих мест, иногда часть аренды. Финальный перечень и проценты определяются региональными правилами — сверяйте с требованиями вашего отдела соцзащиты.",
  },
];

export default function FaqPage({ navigate, user, onLogin, onAccount, showBlog = true, onShareSite }) {
  useEffect(() => {
    document.title = "СоцПлан | Вопросы";
  }, []);
  return (
    <div className="min-h-screen bg-slate-100 py-6 md:py-10">
      <div className="mx-auto w-full max-w-5xl rounded-2xl border bg-white shadow-md">
        <Header
          navigate={navigate}
          user={user}
          onLogin={onLogin}
          onAccount={onAccount}
          showBlog={showBlog}
          onShareSite={onShareSite}
        />
        <section className="px-5 md:px-6 py-6">
          <h1 className="text-2xl font-bold mb-4">Вопросы</h1>
          <div className="space-y-4">
            {faqs.map((item, idx) => (
              <details key={idx} className="border-b pb-2">
                <summary className="cursor-pointer font-medium">{item.q}</summary>
                <p className="mt-2 text-slate-700">{item.a}</p>
              </details>
            ))}
          </div>
        </section>
      </div>
    </div>
  );
}
